import React from 'react'

const FilterMenu = ({ menuNav, MenuFilter }) => {
    return (
        <>
            <h2 className='text-center text-uppercase fw-bold pt-5'>Filter by Category</h2>
            <div className="d-flex justify-content-center align-items-center py-3 flex-wrap">
                {
                    menuNav.map((e, i) => {
                        return <button type="button" key={i} className="btn btn-warning btn-lg mx-3 text-capitalize mb-2" onClick={() => MenuFilter(e)}>{e}</button>
                    })
                }
            </div>
        </>
    )
}

export default FilterMenu
